import { ChangeDetectionStrategy, Component, input } from '@angular/core';

import { ComponentVariantTransform, type Variants } from '../../utils/variant/variant';

@Component({
  selector: 'rt-message',
  templateUrl: './message.component.html',
  styleUrls: ['./message.component.less'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: {
    '[class]': 'variant()',
    '[class.text-wrap]': 'textWrap()',
  },
  standalone: true,
})
export class MessageComponent {
  public static readonly VARIANTS: Variants = [
    'default',
    [
      'default',
      'context-information',
      'context-error',
      'context-warning',
      'context-success',
      'context-brand',
      'small',
      'no-padding',
    ],
  ];
  public readonly variant = input(...ComponentVariantTransform(MessageComponent.VARIANTS));
  public readonly textWrap = input<boolean>(false);
}
